// Mock data for Decision Tracker Table
// Organized by user: Sam (manufacturing) and Monica (retail)

export const monicaRetailData = [
  {
    id: 1,
    product: 'Milk',
    name: 'Milk',
    Mar: 19.2,
    Apr: 19.5,
    May: 19.0,
    Jun: 19.6,
    Jul: 19.8,
    Aug: 19.3,
    decisions: [
      {
        id: 1,
        date: 'Jul 15, 2025',
        decision: 'Markdown by 15%',
        product: 'Oat Milk',
        disruptionReason: 'Heatwave',
        decisionBy: 'Monica',
        predictedOutcome: 'Predicted volume -10%',
        actualOutcome: 'Volume -12%; margin stable'
      },
      {
        id: 2,
        date: 'Jul 18, 2025',
        decision: 'Transfer 500 units',
        product: 'Gentle Stomach Milk',
        disruptionReason: 'Spoilage risk',
        decisionBy: 'Sam',
        predictedOutcome: 'Predicted volume +5%',
        actualOutcome: 'Volume +7%; margin +2%'
      }
    ]
  },
  {
    id: 2,
    product: 'Yogurt',
    name: 'Yogurt',
    Mar: 19.7,
    Apr: 19.7,
    May: 19.9,
    Jun: 19.3,
    Jul: 19.6,
    Aug: 19.8,
    decisions: [
      {
        id: 3,
        date: 'Aug 5, 2025',
        decision: 'Markdown by 20%',
        product: 'Greek Yogurt 500g',
        disruptionReason: 'Spoilage',
        decisionBy: 'Parker',
        predictedOutcome: 'Predicted volume -8%',
        actualOutcome: 'Volume -10%; margin -3%'
      },
      {
        id: 4,
        date: 'Aug 10, 2025',
        decision: 'Transfer 300 units',
        product: 'Low-Fat Yogurt',
        disruptionReason: 'Heatwave',
        decisionBy: 'Monica',
        predictedOutcome: 'Predicted volume +3%',
        actualOutcome: 'Volume +4%; margin stable'
      }
    ]
  },
  {
    id: 3,
    product: 'Cheese',
    name: 'Cheese',
    Mar: 19.5,
    Apr: 19.6,
    May: 20.0,
    Jun: 19.4,
    Jul: 19.5,
    Aug: 19.7,
    decisions: [
      {
        id: 5,
        date: 'Jun 22, 2025',
        decision: 'Markdown by 10%',
        product: 'Cheddar Cheese Block',
        disruptionReason: 'Heatwave',
        decisionBy: 'Sam',
        predictedOutcome: 'Predicted volume -5%',
        actualOutcome: 'Volume -6%; margin stable'
      },
      {
        id: 6,
        date: 'Jul 1, 2025',
        decision: 'Transfer 200 units',
        product: 'Mozzarella Cheese',
        disruptionReason: 'Spoilage risk',
        decisionBy: 'Parker',
        predictedOutcome: 'Predicted volume +8%',
        actualOutcome: 'Volume +9%; margin +1%'
      }
    ]
  }
];

export const samManufacturingData = [
  {
    id: 1,
    product: 'Home Theatre Equipment',
    name: 'Home Theatre Equipment',
    Mar: 68.5,
    Apr: 69.2,
    May: 69.8,
    Jun: 69.1,
    Jul: 69.4,
    Aug: 69.6,
    recommendations: [
      {
        sku_id: 'PART_01',
        item_name: 'Ferrite magnet discs',
        quantity_on_hand: 905,
        daily_sales: 69,
        quantity_to_order: 3248,
        stockout_risk: 'high',
        recommendation_type: 'movement',
        rec_id: 'rec_001_20251121_064456809_001'
      },
      {
        sku_id: 'PART_02',
        item_name: 'Wire mesh grilles',
        quantity_on_hand: 1112,
        daily_sales: 69,
        quantity_to_order: 7670,
        stockout_risk: 'high',
        recommendation_type: 'movement',
        rec_id: 'rec_001_20251121_064456809_005'
      },
      {
        sku_id: 'PART_03',
        item_name: 'Banana plug terminals',
        quantity_on_hand: 1458,
        daily_sales: 69,
        quantity_to_order: 14984,
        stockout_risk: 'high',
        recommendation_type: 'movement',
        rec_id: 'rec_001_20251121_064456809_006'
      }
    ],
    decisions: [
      {
        id: 1,
        date: 'Nov 21, 2025',
        decision: 'Expedite order by switching to FedEx Air Freight',
        product: 'Ferrite magnet discs',
        disruptionReason: 'Shipping Disruptions',
        decisionBy: 'Sam',
        predictedOutcome: 'Reduce fulfillment risk by 45%',
        actualOutcome: 'Risk reduced to 12%; Cost +8%'
      },
      {
        id: 2,
        date: 'Nov 21, 2025',
        decision: 'Expedite order by switching to FedEx Air Freight',
        product: 'Wire mesh grilles',
        disruptionReason: 'Shipping Disruptions',
        decisionBy: 'Sam',
        predictedOutcome: 'Reduce fulfillment risk by 56%',
        actualOutcome: 'Risk reduced to 18%; Cost +9%'
      },
      {
        id: 3,
        date: 'Nov 11, 2025',
        decision: 'Expedite order by switching to FedEx Air Freight',
        product: 'Banana plug terminals',
        disruptionReason: 'Shipping Disruptions',
        decisionBy: 'Sam',
        predictedOutcome: 'Reduce fulfillment risk by 67%',
        actualOutcome: 'Risk reduced to 15%; Cost +7%'
      }
    ]
  },
  {
    id: 2,
    product: 'Car Audio Equipment',
    name: 'Car Audio Equipment',
    Mar: 71.2,
    Apr: 70.9,
    May: 71.4,
    Jun: 71.0,
    Jul: 71.3,
    Aug: 71.1,
    recommendations: [
      {
        sku_id: 'PART_04',
        item_name: 'Speaker cone paper (12" sheets)',
        quantity_on_hand: 1685,
        daily_sales: 69,
        quantity_to_order: 14984,
        stockout_risk: 'high',
        recommendation_type: 'movement',
        rec_id: 'rec_001_20251121_064456809_006'
      },
      {
        sku_id: 'PART_05',
        item_name: 'Foam surround rings (various sizes)',
        quantity_on_hand: 1252,
        daily_sales: 69,
        quantity_to_order: 10410,
        stockout_risk: 'high',
        recommendation_type: 'movement',
        rec_id: 'rec_001_20251121_064456809_002'
      }
    ],
    decisions: [
      {
        id: 4,
        date: 'Nov 16, 2025',
        decision: 'Expedite order by switching to FedEx Air Freight',
        product: 'Speaker cone paper (12" sheets)',
        disruptionReason: 'Shipping Disruptions',
        decisionBy: 'Sam',
        predictedOutcome: 'Reduce fulfillment risk by 23%',
        actualOutcome: 'Risk reduced to 46%; Cost +6%'
      },
      {
        id: 5,
        date: 'Nov 17, 2025',
        decision: 'Expedite order by switching to FedEx Air Freight',
        product: 'Foam surround rings (various sizes)',
        disruptionReason: 'Shipping Disruptions',
        decisionBy: 'Sam',
        predictedOutcome: 'Reduce fulfillment risk by 78%',
        actualOutcome: 'Risk reduced to -9%; Cost +10%'
      }
    ]
  },
  {
    id: 3,
    product: 'Outdoor Audio Equipment',
    name: 'Outdoor Audio Equipment',
    Mar: 68.5,
    Apr: 69.6,
    May: 70.0,
    Jun: 69.4,
    Jul: 69.5,
    Aug: 69.7,
    recommendations: [
      {
        sku_id: 'PART_14',
        item_name: 'Neodymium magnet strips',
        quantity_on_hand: 36028,
        daily_sales: 3,
        quantity_to_order: 2564,
        stockout_risk: 'low',
        recommendation_type: 'movement',
        rec_id: 'rec_001_20251121_064456809_004'
      },
      {
        sku_id: 'PART_13',
        item_name: 'Rubber gaskets (O-ring style, various sizes)',
        quantity_on_hand: 30233,
        daily_sales: 0,
        quantity_to_order: 7610,
        stockout_risk: 'low',
        recommendation_type: 'movement',
        rec_id: 'rec_001_20251121_064456809_003'
      }
    ],
    decisions: [
      {
        id: 6,
        date: 'Nov 05, 2025',
        decision: 'Switch to alternate supplier ChipSource Ltd',
        product: 'Neodymium magnet strips',
        disruptionReason: 'Shipping Disruptions',
        decisionBy: 'Sam',
        predictedOutcome: 'Reduce fulfillment risk by 36%',
        actualOutcome: 'Risk maintained at 3%; Cost -4%'
      },
      {
        id: 7,
        date: 'Nov 07, 2025',
        decision: 'Switch to alternate supplier ChipSource Ltd',
        product: 'Rubber gaskets (O-ring style, various sizes)',
        disruptionReason: 'Shipping Disruptions',
        decisionBy: 'Sam',
        predictedOutcome: 'Reduce fulfillment risk by 86%',
        actualOutcome: 'Risk maintained at 0%; Cost -6%'
      }
    ]
  }
];

/**
 * Get mock data based on user email
 * @param userEmail - The user's email address
 * @returns The appropriate mock data set (Sam's manufacturing or Monica's retail)
 */
export const getMockDecisionData = (userEmail?: string) => {
  if (userEmail?.trim()?.toLowerCase() === 'sam@kimaru.ai') {
    return samManufacturingData;
  }
  return monicaRetailData;
};
